/* eslint-disable class-methods-use-this */
if (!customElements.get("highlighted-text")) {
  class HighlightedText extends HTMLElement {
    connectedCallback() {
      // Only process if the content is not already defined
      if (this.innerHTML.includes("highlighted-text__part--highlighted")) {
        return; // Skip if it's already highlighted
      }
      // Grab the attributes from the component
      const text = this.getAttribute("text");
      const highlightedText = this.getAttribute("highlighted-text");
      const color = this.getAttribute("color") || "var(--background-color--default)";
      const classes = this.getAttribute("classes") || "";
      const colorHighlight = this.getAttribute("color-highlight") || "var(--color--primary)";
      const tag = this.getAttribute("tag") || "span"; // Default to 'span' if no tag is provided

      // Highlight the text and set it to the inner HTML
      this.innerHTML = this.createHighlightedText(text, classes, highlightedText, colorHighlight, color, tag);
    }

    // Method to create the highlighted text and wrap it in a specified tag
    createHighlightedText(text, classes, highlightedText, colorHighlight, color, tag) {
      // Escape any special characters in the highlightedText for regex matching
      const escapedHighlightedText = highlightedText.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
      const regex = new RegExp(escapedHighlightedText, "g");

      // Create the highlighted HTML with the color and highlight class
      const highlightedPart = `<span class="highlighted-text__part--highlighted" style="color: ${colorHighlight};" role="mark">${highlightedText}</span>`;
      const textWithHighlight = text.replace(regex, highlightedPart);

      // Return the full text with the highlighted part inside the specified tag
      return `<${tag} class="highlighted-text ${classes}" style="color:${color};">${textWithHighlight}</${tag}>`;
    }
  }

  // Define the custom element
  customElements.define("highlighted-text", HighlightedText);
}
